import ApiClient from '../../../lib/ApiClient'

const UserService = {
  // Métodos para el usuario autenticado
  async getCurrentUser() {
    try {
      const response = await ApiClient.get('/users/me')
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  async updateCurrentUser(userData) {
    try {
      // Filtramos campos protegidos antes de enviar
      const filteredData = this.filterProtectedFields(userData)
      const response = await ApiClient.put('/users/me', filteredData)
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  async updatePassword({ currentPassword, newPassword }) {
    try {
      const response = await ApiClient.put('/users/me/password', {
        currentPassword,
        newPassword,
      })
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  async deleteCurrentUser() {
    try {
      await ApiClient.delete('/users/me')
      return true
    } catch (error) {
      throw this.handleError(error)
    }
  },

  async getCurrentUserExploitations() {
    try {
      const response = await ApiClient.get('/users/me/exploitations')
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  async getPreferences() {
    try {
      const response = await ApiClient.get('/users/me/preferences')
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  async updatePreferences(preferences) {
    try {
      const response = await ApiClient.put('/users/me/preferences', preferences)
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // Métodos de registro (públicos)
  async createUser(userData) {
    if (!userData || typeof userData !== 'object') {
      throw new Error('Datos de usuario no válidos')
    }

    try {
      const response = await ApiClient.post('/users/register', userData)
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // Helper para filtrar campos protegidos
  filterProtectedFields(userData) {
    if (!userData || typeof userData !== 'object') {
      return {}
    }

    const {
      role,
      username,
      password,
      verified,
      createdAt,
      updatedAt,
      id,
      ...safeData
    } = userData

    return safeData
  },

  // Manejo de errores
  handleError(error) {
    let errorMessage = 'Error al procesar la solicitud'
    let errorDetails = null
    let statusCode = null

    if (error.response) {
      statusCode = error.response.status

      if (statusCode === 403 && error.response.data?.error) {
        errorMessage = error.response.data.error
      } else {
        errorMessage =
          error.response.data?.message ||
          error.response.data?.error ||
          `Error ${statusCode}: ${error.response.statusText}`
      }

      if (error.response.data?.errors) {
        errorDetails = error.response.data.errors
      }
    } else if (error.request) {
      errorMessage = 'El servidor no respondió'
    } else {
      errorMessage = error.message || errorMessage
    }

    const formattedError = new Error(errorMessage)
    formattedError.details = errorDetails
    formattedError.status = statusCode
    formattedError.isAuthError = statusCode === 401 || statusCode === 403

    return formattedError
  },

  // Manejo específico para errores de imágenes
  handleImageError(error) {
    console.error('Error al cargar imagen:', error)
    const formattedError = this.handleError(error)

    // Personalización adicional para errores de imágenes
    if (
      !formattedError.message.includes('imagen') &&
      !formattedError.message.includes('avatar')
    ) {
      formattedError.message =
        'Error al procesar la imagen: ' + formattedError.message
    }

    return formattedError
  },
}

export default UserService
